import { useSafetyTranslation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button/Button'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { CockpitSectionHeader } from '../../../components/cockpitSectionHeader'
import type { IDocumentsTreeGroup } from '../../lib/buildDocumentsTreeGroups'
import { DocumentsTreeTable } from '../documentsTreeTable/DocumentsTreeTable'

import styles from './DocumentsTreeGroup.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks
export const DocumentsTreeGroup = ({
  group,
  readOnly,
  country,
  expanded,
  onToggle,
}: {
  group: IDocumentsTreeGroup
  readOnly: boolean
  country?: string
  expanded: boolean
  onToggle: () => void
}) => {
  const t = useSafetyTranslation()
  const label = group.label || t(KEYS.treeDocuments.unknownCreator)
  return (
    <section className={styles.root}>
      <Button color="grey" className={styles.trigger} onClick={onToggle}>
        <CockpitSectionHeader
          inline
          actions={<span className={styles.count}>{group.rows.length}</span>}
        >
          <span className={styles.caption}>
            <i className={`kbase ${expanded ? 'kbase-chevron-bottom' : 'kbase-chevron-right'}`} />
            <span className={styles.name}>{label}</span>
            {country && <span className={styles.country}>{country}</span>}
          </span>
        </CockpitSectionHeader>
      </Button>
      {expanded && <DocumentsTreeTable rows={group.rows} readOnly={readOnly} />}
    </section>
  )
}
